const About = () => {
  return (
    <div>
      <h1>About this App</h1>
      <p>App to search Github users</p>
    </div>
  );
};

export default About;
